import { defineBlock } from "eddev/blocks"
import { Col, Container, Grid } from "@components/layout/Grid"
import { VSpace } from "@components/layout/Spacer"
import { useIsMobile } from "@hooks/useViewportDerived"
import { tv } from "@utils/tw"
import { Button } from "@components/atoms/Button"
import { Typography } from "@components/atoms/Typography"
import { Fragment } from "react"

export const meta: BlockMeta = {
  title: "File download group",
  category: "common",
  icon: "download",
  keywords: ["file", "download"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/file-download-group", (props) => {
  const isMobile = useIsMobile()

  return (
    <Container className="my-6">
      <Grid>
        {props.files?.map((file, i) => (
          <Fragment key={i}>
            {!isMobile && !env.admin && <Col initial={12} tablet={1} laptop={2} />}
            <Col initial={12} tablet={env.admin ? 12 : 10} laptop={env.admin ? 12 : 8}>
              <FileDownload
                title={file?.title ?? ""}
                file={file?.file?.mediaItemUrl ?? ""}
                size={file?.file?.fileSize ?? 0}
                underline={props.files!.length === i + 1 ? true : false}
              />
            </Col>
            {!isMobile && !env.admin && <Col initial={12} tablet={1} laptop={2} />}
          </Fragment>
        ))}
      </Grid>
    </Container>
  )
})

export const FileDownload = ({
  title,
  file,
  size,
  underline,
}: {
  title: string
  file: string
  size: number
  underline?: boolean
}) => {
  return (
    <div className={fileStyles({ underline })}>
      <div className="flex flex-col grow [&_h4]:my-0">
        <Typography as="h4" variant="h4">
          {title}
        </Typography>
        <VSpace initial={2} />
        <Typography as="span" variant="caps">
          {(size / 1000).toFixed(2)}kB
        </Typography>
      </div>
      <Button size="medium" color="yellow" icon="DOWNLOAD" iconStyle="left" href={file}>
        Download
      </Button>
    </div>
  )
}

const fileStyles = tv({
  base: "w-full flex gap-6 border-t border-light-grey items-start justify-between py-4 flex-col [&>a]:w-full [&>a]:box-border sm:flex-row sm:items-center sm:[&>a]:w-auto",
  variants: {
    underline: {
      true: "border-b border-light-grey",
    },
  },
})
